module.exports = __webpack_public_path__ + "media/images/emblems/BettingenWappen-b697837151bb0ab86d1f2c521b96d290.gif";